(function() {
    window.c24.lp.ac.inv = {

        ac: null,

        init: function(ac) {

            this.ac = ac,
            this.button = $('.c24Button', this.ac);

            $('.widgetWrapper form', this.ac).on('submit',function () {
                const radioSelector = $('input[name=\'select_type\']:checked');
                const radioUrl = radioSelector.data('url');
                $(this).attr('action',radioUrl) ;
            });
        },
    };

    $(document).ready(function() {

        $.each($('.mod24ac.inv'), function (_, ac) {
            const inv = Object.create(window.c24.lp.ac.inv);
            inv.init(ac);
        });

    });
})();
